export const ChallengeActionTypes = {
    CHALLENGE_LIST_REQUEST: 'CHALLENGE_LIST_REQUEST',
    CHALLENGE_LIST_SUCCESS: 'CHALLENGE_LIST_SUCCESS',
    CHALLENGE_LIST_FAIL: 'CHALLENGE_LIST_FAIL',
    SET_CHALLENGES: 'SET_CHALLENGES',
    REMOVE_CHALLENGES: 'REMOVE_CHALLENGES'
  }